import { Component } from '@angular/core';

import {
  AdvancedFilterModel,
  BooleanAdvancedFilterModel,
  BooleanAdvancedFilterModelType,
  IFilterParams,
  JoinAdvancedFilterModel,
} from 'ag-grid-enterprise';

import { TranslatePipe } from '@camelot/translation';
import { TextComponent } from '@camelot/ui';
import { isNonNullable } from '@camelot/utils';

import { ActiveFilterTag } from '../../../../filters/types';
import { CamTranslationGrid } from '../../../translation.service';
import { BaseFilterComponent } from '../base-col';
import type { BoolCol } from './bool-col';

@Component({
  host: { 'data-cid': 'bool-filter' },
  imports: [TranslatePipe, TextComponent],
  styleUrls: ['../filter.scss'],
  template: `
    <div>
      <div class="filter-title">
        <cam-text [isBold]="true" size="sm" color="brand-primary">{{ this.filterTitle() | translate }}</cam-text>
      </div>
      <div class="p-space-sm">
        <div class="flex-start g-space-sm align-center p-space-xs" (click)="this.toggle('true')">
          <input type="checkbox" [checked]="this.isSelected('true')" />
          <cam-text>
            {{ 'grid.common.true' | translate }}
          </cam-text>
        </div>
        <div class="flex-start g-space-sm align-center p-space-xs" (click)="this.toggle('false')">
          <input type="checkbox" [checked]="this.isSelected('false')" />
          <cam-text>
            {{ 'grid.common.false' | translate }}
          </cam-text>
        </div>
      </div>
    </div>
  `,
})
export class BoolFilterComponent extends BaseFilterComponent<
  JoinAdvancedFilterModel | BooleanAdvancedFilterModel,
  BoolCol
> {
  constructor() {
    super();
    CamTranslationGrid.getInstance();
  }

  override agInit(params: IFilterParams) {
    super.agInit(params);
  }

  override getTags(model?: AdvancedFilterModel | null): ActiveFilterTag[] {
    if (!model) {
      model = this._model;
    }
    if (!model) {
      return [];
    }
    if (model.filterType === 'boolean') {
      if (!isNonNullable(model.type)) {
        return [];
      }
      return [
        {
          condition: model,
          id: model.colId,
          name: model.type === 'true' ? 'grid.common.true' : 'grid.common.false',
        },
      ];
    }

    return [];
  }

  public toggle(type: BooleanAdvancedFilterModelType) {
    const data: any = [];
    data[this._col?.key ?? ''] = this.isSelected(type) ? null : type;

    super.apply(data);
  }
  public isSelected(type: BooleanAdvancedFilterModelType) {
    return this._col?.value === type;
  }
}
